import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import TableViewer from "../../../component/tableViewer/TableViewer";

const CompletedLeads = () => {
  const token = config.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [leadprofiles, setLeadprofiles] = useState([]);
  //  ------For TableViewer ------
  const leadprofilesRef = useRef([]);
  leadprofilesRef.current = leadprofiles;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //--------------------------------------------------------- get lead-profile leadprofile ---------------------------------------------------------r

  const getLeadProfile = () => {
    setLoading(true);
    fetch(`${config.host_url}lead-profile/completed`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          // console.log(data.data);
          setLeadprofiles(data.data);

          //  ------For TableViewer ------
          const leadprofilesData = data.data.map((leadprofile) => ({
            name:
              leadprofile.first_name_of_lead +
              " " +
              leadprofile.last_name_of_lead,
            email: leadprofile.email_1 + ", " + leadprofile.email_2,
            address:
              leadprofile.city +
              ", " +
              leadprofile.state +
              ", " +
              leadprofile.country,
            lead_source_type: leadprofile.lead_source_type,
            type_of_lead: leadprofile.type_of_lead,
            idNumber: leadprofile.lead_profile_id,
          }));
          setRowData(leadprofilesData);
          //  ------For TableViewer ------
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getLeadProfile();
  }, [token]);

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "name", filter: true },
    { field: "email", filter: true },
    { field: "address", filter: true },
    { field: "lead_source_type", filter: true },
    { field: "type_of_lead", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Lead Profile" subpath={["Completed Leads"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">Completed Leads</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addleadprofile");
                }}
              >
                Add Lead Profile
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer rowData={rowData} colDefs={colDefs} />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CompletedLeads;
